module.exports = __webpack_public_path__ + "img/722ef6e.jpg";